import { TaxRate } from '@dreryk/egabinet-private-medical-service-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { Bean, BindingCreator } from '@dreryk/react-common';
import { InteractiveTable, StyledFlex } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';
import { invoiceTypeVisitor } from '../InvoiceCreateForm.utils';

import { useInvoiceItemsColumns } from './InvoiceItemsTable.hooks';
import { InvoiceItemsTableBean } from './InvoiceItemsTable.types';
import { addEmptyRow } from './InvoiceItemsTable.utils';
import { TotalGrossPrice } from './TotalGrossPrice';

const INVOICE_ITEMS_TABLE_NAME = 'invoiceItems';

export type InvoiceItemsFormBeanPart = {
   [INVOICE_ITEMS_TABLE_NAME]: InvoiceItemsTableBean[];
};

type InvoiceItemsTableProps = Readonly<{
   invoiceItems: InvoiceItemsTableBean[] | undefined;
   register: BindingCreator<InvoiceItemsFormBeanPart, string>;
   taxRates: TaxRate[];
   receiptAvailableForInvoice: boolean;
   practitionerId: PractitionerId | undefined;
}>;

export const InvoiceItemsTable = (props: InvoiceItemsTableProps): JSX.Element => {
   return (
      <InteractiveTable<InvoiceItemsTableBean, Bean>
         name={INVOICE_ITEMS_TABLE_NAME}
         register={props.register}
         columns={useInvoiceItemsColumns({
            taxRates: props.taxRates,
            receiptAvailableForInvoice: props.receiptAvailableForInvoice,
            practitionerId: props.practitionerId,
         })}
         testId={INVOICE_ITEMS_TABLE_NAME}
      >
         {invoiceTypeVisitor(props.receiptAvailableForInvoice)({
            withReceipt: () => (
               <StyledFlex justifyContent={'flex-end'} gap={8}>
                  <TotalGrossPrice invoiceItems={props.invoiceItems} />
               </StyledFlex>
            ),
            default: () => (
               <StyledFlex justifyContent={'space-between'} gap={8}>
                  <InteractiveTable.AddRowButton
                     label={invoiceCreateModalTranslationKeys.table.addService}
                     onAddRow={addEmptyRow}
                  />
                  <TotalGrossPrice invoiceItems={props.invoiceItems} />
               </StyledFlex>
            ),
         })}
      </InteractiveTable>
   );
};
